// login.component.ts
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../ui/spinner/spinner.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    imports: [CommonModule, ReactiveFormsModule, SpinnerComponent]
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  // Sign-up is disabled for now (product decision) — kept commented instead
  // of removed in case it's needed again. There is no route/query-param
  // path into sign-up either; this component-local flag was the only entry
  // point, and it's now unused. See signUp()/toggleSignUpMode() below and
  // the matching commented-out markup in login.component.html.
  // isSignUpMode: boolean = false;
  errorText: string = '';
  isLoadingSpinner: boolean = false;
  showSignUp: boolean = false;
  // True only when /getConfig failed to load. Login itself still works when
  // this is true — showSignUp just safely defaults to false — this only
  // drives a small branded notice instead of leaving the spinner stuck
  // forever (a pre-existing gap fixed as part of post-rebrand QA).
  configLoadError: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      email: [''],
      password: [''],
    });
  }

  ngOnInit(): void {
    this.isLoadingSpinner = true;
    this.authService.isLogged().subscribe({
      next: (isLogged) => {
        if (isLogged) {
          this.redirectToCLients();
        } else {
          this.authService.getInitialConfig().subscribe({
            next: (config) => {
              this.showSignUp = config.showSignUp;
              this.isLoadingSpinner = false;
            },
            error: (error) => {
              console.error('Error loading initial config', error);
              // Config only gates the optional sign-up/Google affordances —
              // login itself must keep working, so default them off and
              // surface a small branded notice rather than blocking the form.
              this.showSignUp = false;
              this.configLoadError = true;
              this.isLoadingSpinner = false;
            },
          });
        }
      },
    });
  }

  login(): void {
    const { email, password } = this.loginForm.value;
    this.authService.login(email, password).subscribe({
      next: () => this.redirectToCLients(),
      error: (error) => (this.errorText = 'Login failed: ' + error.message),
    });
  }

  // Sign-up disabled — see the note on isSignUpMode above.
  // signUp(): void {
  //   const { email, password } = this.loginForm.value;
  //   this.authService.signUp(email, password).subscribe({
  //     next: () => this.redirectToCLients(),
  //     error: (error) => (this.errorText = 'Sign up failed: ' + error.message),
  //   });
  // }

  loginWithGoogle(): void {
    this.authService.loginWithGoogle().subscribe({
      next: () => this.redirectToCLients(),
      error: (error) =>
        (this.errorText = 'Google login failed: ' + error.message),
    });
  }

  // Sign-up disabled — see the note on isSignUpMode above.
  // toggleSignUpMode(): void {
  //   this.isSignUpMode = !this.isSignUpMode;
  //   this.errorText = '';
  // }

  private redirectToCLients(): void {
    this.router.navigate(['/list-merchant']);
  }
}
